import React from 'react';
import {LeftSidebar, RightSidebar} from "../index";
import Users from "../users/users";

const Main = ({userSecTitle, userSecChildren, children, userSecAction = null}) => {
    return (
        <div className='d-flex align-items-start'>
            <LeftSidebar/>
            <Users title={userSecTitle}
                   userSecAction={userSecAction}>
                {userSecChildren}
            </Users>
            {children}
            <RightSidebar/>
        </div>

    );
};

export default Main;
